import { useEffect, useState, type ReactElement } from "react";
import { useNavigate } from "react-router-dom";

import { api, setAccessToken } from "../api/client";
import type { TokenResponse, User } from "../api/types";
import { useAuth } from "../auth/AuthContext";

// Landing spot after the OIDC callback. The callback set the httpOnly refresh
// cookie; here we mint an access token from it, resolve the profile, and route
// by role — the same end state as a password login.
export function SsoDone(): ReactElement {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const res = await api<TokenResponse>("POST", "/auth/refresh", { auth: false });
        setAccessToken(res.access_token);
        const me = await api<User>("GET", "/auth/me");
        await refreshUser();
        if (cancelled) return;
        const home =
          me.role === "admin" ? "/admin" : me.role === "collaborator" ? "/collab" : "/app";
        navigate(home, { replace: true });
      } catch {
        if (cancelled) return;
        setFailed(true);
        navigate("/login?sso_error=failed", { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate, refreshUser]);

  return (
    <div className="full-center muted">{failed ? "Sign-in failed." : "Completing sign-in…"}</div>
  );
}
